<template>
  <div class="tnps-feedback">
    <slot name="txtBefore"></slot>
    <div v-if="feedbackQuestions.active === false" class="survey-inactive">
      <slot name="surveyInactive"><div>Vielen Dank für Ihr Interesse, die Umfrage ist beendet.</div></slot>
    </div>
    <FeedbackForm v-if="showFeedbackForm" :questions="feedbackQuestions.questions" @update:answers="updateAnswers">
      <template v-for="slot in possibleChildSlotsFor('Form')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </FeedbackForm>
    <Success
      v-if="showSuccess"
      :show-prev="false"
    >
      <template v-for="slot in possibleChildSlotsFor('Success')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </Success>
    <slot name="txtAfter"></slot>
    <Stepper
      :show-prev="false"
      :show-next="showFeedbackForm"
      @next="next"
    >
      <template v-for="slot in possibleChildSlotsFor('Stepper')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </Stepper>
  </div>
</template>

<script>
import transaction from '../../../../mixins/transaction'
import slotProxy from '../../../../mixins/slotProxy'
import gql from 'graphql-tag'
import FeedbackForm, { stepName as feedbackFormStepName } from './Form.vue'
import Success, { stepName as successStepName } from '../../../generic/Success.vue'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import Stepper from '../../../generic/Stepper.vue'
import { splitError } from '@/helper/splitError'

export default {
  name: 'FeedbackProcessWrapper',
  components: { Stepper, Success, FeedbackForm },
  data () {
    return {
      feedbackQuestions: {
        active: null,
        questions: []
      },
      answers: {},
      timestamp: null
    }
  },
  async mounted () {
    const urlParameters = new URLSearchParams(window.location.search)
    const solicitorId_ = urlParameters.get('solicitorId')
    const timestamp = urlParameters.get('t')
    this.setSolicitorId(solicitorId_)
    this.timestamp = timestamp
    this.getQuestions()
  },
  methods: {
    updateAnswers (answers) {
      this.answers = answers
    },
    async next () {
      this.loadingPrev = true
      await this.sendAnswers({ questions: this.feedbackQuestions.questions, answers: this.answers, successStepName })
      this.loadingPrev = false
    },
    getQuestions: function () {
      const me = this
      const graphQlClient = me.$apolloProvider.defaultClient

      graphQlClient.query({
        query: gql`query tnpsFeedback ($brand: String!, $solicitorId: String!, $timestamp: String!) {
            feedbackQuestions(feedbackRequest: {
              brand: $brand
              solicitorId: $solicitorId
              validityTimestamp: $timestamp
            }) {
              active
              questions {
                questionText
                id
                answerType
                ...on FulltextQuestion {
                  maxLength
                }
                ... on NumberRangeQuestion {
                  lowerBoundary
                  lowerBoundaryText
                  upperBoundary
                  upperBoundaryText
                }
              }
            }
        }`,
        variables: {
          brand: this.brand,
          solicitorId: this.solicitorId,
          timestamp: this.timestamp
        }
      }).then(response => {
        if (response.data.feedbackQuestions !== null) {
          this.feedbackQuestions = response.data.feedbackQuestions
        }
      }).catch((error) => {
        splitError(error).forEach(e => me.$store.commit('addError', e))
      })
    },
    ...mapMutations('feedbackProcess', ['changeStep', 'setSolicitorId']),
    ...mapActions('feedbackProcess', ['sendAnswers'])
  },
  mixins: [
    transaction('tnpsFeedback'),
    slotProxy()
  ],
  computed: {
    showFeedbackForm () {
      return this.getStep === feedbackFormStepName && this.feedbackQuestions.active
    },
    showSuccess () {
      return this.getStep === successStepName
    },
    ...mapGetters('feedbackProcess', ['getStep', 'solicitorId']),
    ...mapGetters(['brand'])
  }
}
</script>
